// @flow
import * as React from 'react';
import ReactDOM from 'react-dom';

type Props = {|
  anchor: ?HTMLElement,
  children: React.Node,
  subjectHeightOverride?: number,
  subjectWidthOverride?: number,
|};

type State = {|
  horizontalOffset: number,
  verticalOffset: number,
|};

export default class Center extends React.Component<Props, State> {
  state = {
    horizontalOffset: 0,
    verticalOffset: 0,
  };

  componentDidMount() {
    this.positionSubject();
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    // Updating props or state (for example, calculating the subject position)
    // triggers a render (even if when updating with identical values),
    // so only render if props or state are replaced with new values.
    const { props, state } = this;
    return !(
      Object.keys(props).every((key) => props[key] === nextProps[key]) &&
      Object.keys(state).every((key) => state[key] === nextState[key])
    );
  }

  componentDidUpdate() {
    const subject = this._subject;

    if (subject) {
      const subjectRect = subject.getBoundingClientRect();

      if (subjectRect.width !== this._subjectWidth) {
        this.positionSubject();
      }
    }
  }
  _subject: ?HTMLDivElement;
  _subjectWidth: number;

  calculateAndSetOffsets = (
    anchorHeight: number,
    anchorWidth: number,
    subjectHeight: number,
    subjectWidth: number,
  ) => {
    const anchorHalfWidth = anchorWidth / 2;
    const anchorHalfHeight = anchorHeight / 2;

    this._subjectWidth = subjectWidth;

    const subjectHalfWidth = (this.props.subjectWidthOverride || subjectWidth) / 2;
    const subjectHalfHeight = (this.props.subjectHeightOverride || subjectHeight) / 2;

    const horizontalOffset = -(subjectHalfWidth - anchorHalfWidth);
    const verticalOffset = -(subjectHalfHeight - anchorHalfHeight);

    this.setState({
      horizontalOffset,
      verticalOffset,
    });
  };

  positionSubject = () => {
    // this works for positioning pulser over smaller element and position:relative parent
    // TODO (briantran): Expand to other cases like Subject is smaller (maybe works but need to verify)
    // TODO (briantran): Add centering for when anchoring is not on top left of parent div (like margins,
    // padding, positioning)

    const subject = this._subject;
    const anchor = this.props.anchor;

    if (!(anchor && subject)) {
      return;
    }

    const anchorDomNode = ReactDOM.findDOMNode(anchor);

    if (anchorDomNode && anchorDomNode instanceof Element) {
      const anchorRect = anchorDomNode.getBoundingClientRect();
      const subjectRect = subject.getBoundingClientRect();

      const { height: anchorHeight, width: anchorWidth } = anchorRect;
      const { height: subjectHeight, width: subjectWidth } = subjectRect;

      this.calculateAndSetOffsets(anchorHeight, anchorWidth, subjectHeight, subjectWidth);
    }
  };

  render() {
    return (
      <div
        ref={(ref) => {
          this._subject = ref;
        }}
        style={{
          position: 'absolute',
          left: this.state.horizontalOffset,
          top: this.state.verticalOffset,
        }}
      >
        {this.props.children}
      </div>
    );
  }
}
